// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__BQ9ux","label":"LabeledBox_label__1nxgX"};